/**
 * A pub-sub channel for Web Recorder events only.
 *
 * This is how we sync state between distinct components on the page that all depend
 * on the state of the recording.
 */
import EventEmitter from 'eventemitter3'

const eventEmitter = new EventEmitter()

export type Event =
  | 'is-recordable'
  | 'recording-started'
  | 'recording-cleared'
  | 'recording-scheduled'
  | 'apply-action'
  | 'focus-subject'

export function subscribe(event: Event, callback: (val: any) => void) {
  eventEmitter.on(event, callback)
}

export function unsubscribe(event: Event, callback: (val: any) => void) {
  eventEmitter.off(event, callback)
}

export function publish(event: Event, val: any) {
  eventEmitter.emit(event, val)
}
